<!--
    描述：租户用户表单
    日期：2021/04/16
    作者：zwh
-->
<template>
<div class="tua-main-dialog">
    <el-row>
        <el-col :span="24">
            <el-input placeholder="请输入姓名" v-model="searchObj.sname" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
        </el-col>
    </el-row>
    <el-row class="mt5">
        <el-col :span="24">
            <el-table ref="table"
                v-loading="tableObj.loading"
                :data="tableObj.tableData"
                default-expand-all
                :height="tableObj.tableH"
                row-key="id"
                border
                highlight-current-row
                >
                <el-table-column type="index" align="center" width="50"></el-table-column>
                <el-table-column align="center" width="50">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isChecked" @change="handleCheck($event, scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="sname" header-align="center" label="姓名" show-overflow-tooltip width="135"></el-table-column>
                <el-table-column prop="username" header-align="center" label="用户名" show-overflow-tooltip min-width="100"></el-table-column>
            </el-table>
        </el-col>
    </el-row>
    <el-row class="mt5">
        <el-col :span="24" class="text-center">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
               :current-page="tableObj.currentPage" :page-sizes="tableObj.pageList"
               :page-size="tableObj.pageSize" layout="total, sizes, prev, pager, next, jumper"
               :total="tableObj.total"></el-pagination>
        </el-col>
    </el-row>
</div>
</template>
<script>
import { getUnUserTenantTablePageList,saveDeptTenantUserBatch } from 'api/system/sysUserDeptTenant.js'
export default {
    name : '',
    props : {
        mode: {
            type: String,
            default: 'add'
        },
        transObj: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {
    },

    data() {
        return {
            btnLoading: false,
            searchObj : {
                sname : '',
            },
            objectForm: {

            },
            formRules: {

            },
            tableObj: {
                loading: false,
                tableH: 445,
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageList: [10, 20, 50, 100], // 显示条数数组
            },
            //人员选中list
            userCheckedList : [],
            //人员选中id list
            userCheckedIdList : [],
        }
    },
    mounted() {},
    computed: {
        // 是否可编辑
        isDisabled() {
            return this.mode === 'view' ? true : false
        }
    },
    watch: {},
    created() {
        //获取列表信息
        this.getTablePageList()
    },
    methods: {
        //搜索
        search(){
            this.getTablePageList()
        },
        //获取列表信息
        getTablePageList(){
            let that = this
            let param = {
                deptId : this.transObj.deptId,
                current : this.tableObj.currentPage,
                size : this.tableObj.pageSize,
                userSname : this.searchObj.sname
            }
            getUnUserTenantTablePageList(param).then(res => {
                this.tableObj.tableData = []
                this.tableObj.total = 0
                if(res.operationCode == 1 && res.data != null) {
                    let data = res.data.records
                    data.forEach(row=>{
                        let index = that.userCheckedIdList.findIndex(userId=> { return userId == row.id })
                        if(index != -1) row.isChecked = true
                        else row.isChecked = false
                    })
                    this.tableObj.tableData = data
                    this.tableObj.total = parseInt(res.data.total)
                }
            })
        },
        // 数据权限复选框 check 事件
        handleCheck(status, row) {
            let that = this
            console.log(status)
            if(status) that.userCheckedIdList.push(row.id)
            else {
                let index = that.userCheckedIdList.findIndex(userId=> { return userId == row.id })
                that.userCheckedIdList.splice(index,1)
            }
            console.log(that.userCheckedIdList)
        },
        //保存
        doSave(){
            let that = this
            if(this.userCheckedIdList.length < 1) {
                this.$message({ message: '请选择用户！', type: 'warning' })
                return
            }

            let param = {
                deptId : that.transObj.deptId,
                userCheckedIdList : that.userCheckedIdList,
            }
            saveDeptTenantUserBatch(param).then(res=>{
                if(res.operationCode == 1) {
                    this.$message({message: '保存成功！', type: 'success'})
                    this.$emit('handle-success')
                }
            })
        },
        // 切换显示条数
        handleSizeChange(val) {
            this.tableObj.pageSize = val;
            this.getTablePageList()
        },
        // 切换当前页码
        handleCurrentChange(cur) {
            this.tableObj.currentPage = cur;
            this.getTablePageList()
        },
    }
}
</script>
